import './choose';
import './email';
import './linkedin';
import './linkedin-imail';
import './textarea/message';
import './textarea/email';
import './textarea/linkedin-inmail';

export const BULK_MESSAGE_CHOOSE_MODE = 'BULK_MESSAGE_CHOOSE_MODE';
export const BULK_MESSAGE_LINKEDIN_MODE = 'BULK_MESSAGE_LINKEDIN_MODE';
export const BULK_MESSAGE_EMAIL_MODE = 'BULK_MESSAGE_EMAIL_MODE';
export const BULK_MESSAGE_LINKEDIN_INMAIL_MODE = 'BULK_MESSAGE_LINKEDIN_INMAIL_MODE';
